import storage from "redux-persist/lib/storage";
import { configureStore } from "@reduxjs/toolkit";
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";

import rootReducer from "./rootReducer";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["appData", "auth"],
};

// Create store
const store = configureStore({
  reducer: persistReducer(persistConfig, rootReducer),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

// Set up hot module replacement
if (process.env.NODE_ENV === "development" && module.hot) {
  module.hot.accept(() => {
    const newRootReducer = rootReducer;
    store.replaceReducer(persistReducer(persistConfig, newRootReducer));
  });
}

const persistor = persistStore(store);

export { store, persistor };
